import { Redirect, useParams, useHistory } from "react-router-dom";

import CustomerPage from "@/components/CustomerPage";
import SliderTabs, { SliderTab } from "@/components/SliderTabs";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import {
  CMP_PATIENTS_FOOD_LIST_URL,
  CMP_PATIENTS_PROFILE_URL,
  CMP_PATIENTS_QUESTIONNAIRE_URL,
  CMP_PATIENTS_REPORTS_URL,
  CMP_PATIENTS_SUGGESTIONS_URL,
  CMP_PATIENTS_TEST_RESULTS_URL,
  CMP_PATIENTS_WELLNESS_URL,
  ERROR_404_URL,
  getCmpUrl
} from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";
import { gql, useQuery } from "@apollo/client";

const ALL_TABS = [
  {
    label: "profile",
    urlTemplate: CMP_PATIENTS_PROFILE_URL
  },
  {
    label: "test results",
    urlTemplate: CMP_PATIENTS_TEST_RESULTS_URL
  },
  {
    label: "reports",
    urlTemplate: CMP_PATIENTS_REPORTS_URL
  },
  {
    label: "questionnaire",
    urlTemplate: CMP_PATIENTS_QUESTIONNAIRE_URL
  },
  {
    label: "suggestions",
    urlTemplate: CMP_PATIENTS_SUGGESTIONS_URL,
    disabled: true
  },
  {
    label: "food list",
    urlTemplate: CMP_PATIENTS_FOOD_LIST_URL,
    disabled: true
  }
];

const PATIENT_DETAILS = gql`
  query PatientDetails($userId: ID!, $organisationId: ID!) {
    user(userId: $userId, organisationId: $organisationId) {
      id
      firstName
      lastName
    }
  }
`;

export default function Template({
  children,
  selectedTab,
  bodyProps,
  docTitle,
  jumbotronProps,
  excludeTabs
}) {
  const { organisation } = useOrganisationContext();

  const organisationId = organisation?.hashId;

  useDocTitle(docTitle, docTitle === undefined, "Regenerus");

  const { patientId } = useParams();
  const history = useHistory();

  const { data } = useQuery(PATIENT_DETAILS, {
    variables: {
      userId: patientId,
      organisationId: organisation?.id
    },
    skip: !organisation
  });

  const user = data?.user;

  let displayedTabs = ALL_TABS;
  if (excludeTabs) {
    displayedTabs = displayedTabs.filter(tab => !excludeTabs.includes(tab.label));
  }

  return (
    <CustomerPage
      bg="haze"
      jumbotronProps={{
        bg: "partners",
        color: "dark",
        title: user ? `${user.firstName} ${user.lastName}` : null,
        ...jumbotronProps
      }}
      bodyProps={bodyProps}
    >
      {data ? (
        user ? (
          <>
            <SliderTabs
              bg="white"
              tabs={displayedTabs}
              selectedTab={selectedTab}
              withBorder
              renderTab={({ tab, ...props }) => (
                <SliderTab
                  {...props}
                  tab={tab}
                  onClick={() => {
                    history.push(
                      getCmpUrl(tab.urlTemplate, {
                        organisationId,
                        patientId
                      })
                    );
                  }}
                />
              )}
            />
            {children}
          </>
        ) : (
          <Redirect to={ERROR_404_URL} />
        )
      ) : null}
    </CustomerPage>
  );
}
